<template>
    <div>
        <ul>
            <li
                v-for="item in fileItemList"
                :key="item.fileKey"
                class="file-select-item"
            >
                <div
                    :class="['file-list-item', (markedFileList || []).includes(item.fileUrl) ? 'red-border' : '']"
                >
                    <!-- 图片文件 -->
                    <img
                        v-if="isImg(item.fileUrl)"
                        class="file-list-item-thumbnail"
                        :src="item.fileUrl"
                    />
                    <!-- 非图片文件 -->
                    <div
                        v-else
                        class="file-list-item-thumbnail file-list-item-fileName"
                    >
                        {{ `${getFileName(item.fileUrl)}` }}
                    </div>
                    <span
                        class="file-list-item-actions"
                    >
                        <span
                            class="file-list-item-preview"
                            @click="handlePreview(item.fileUrl)"
                        >
                            <i class="el-icon-zoom-in"></i>
                        </span>
                    </span>
                </div>
            </li>
        </ul>
        <!-- 图片预览 -->
        <mc-image-preview
            :visible="showImageViewer"
            :z-index="2000"
            :current-index="imageIndex"
            :data="previewImageList"
            @close="closeImageViewer"
        />
    </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import { linkTo } from '@lsfe/tools';

export default {

    name: 'FileListCard',

    props: {
        showFileName: {
            type: Boolean,
            default: false,
        },
        // 待展示文件项
        fileOptionList: {
            type: Array,
            default() {
                return [];
            },
        },
        // 需要红框标注的文件项
        markedFileList: {
            type: Array,
            default() {
                return [];
            },
        },
    },

    data() {
        return {
            showImageViewer: false,
            imageIndex: -1,
            previewImageList: [],
        };
    },
    computed: {
        fileItemList() {
            return (this.fileOptionList || []).map((item) => ({
                fileUrl: item,
                fileKey: this.$generateId(),
            }));
        },
        imageUrlList() {
            // 获取文件类型是图片的urlList
            return (this.fileOptionList || []).filter((url) => this.isImg(url));
        },
    },
    methods: {
        // 预览文件
        handlePreview(url) {
            if (this.isImg(url)) {
                this.imageIndex = this.imageUrlList.indexOf(url);
                this.showImageViewer = true;
                this.previewImageList = [...this.imageUrlList];
            } else {
                linkTo(url, {}, true);
            }
        },
        closeImageViewer() {
            this.showImageViewer = false;
        },
        getNameByUrl(url) {
            const arr = (url || '').split('/');
            return arr[arr.length - 1];
        },
        getFileType(name) {
            return (name || '').split('.').pop();
        },
        getFileName(fileUrl) {
            const fileName = this.getNameByUrl(fileUrl);
            const fileType = this.getFileType(fileName);
            return this.showFileName ? fileName : `${fileType}文件`;
        },
        isImg(fileUrl) {
            const imgExts = [
                'jpg',
                'png',
                'jpeg',
                'bmp',
                'gif',
                'svg',
            ];
            const fileName = this.getNameByUrl(fileUrl);
            const fileType = this.getFileType(fileName);
            return imgExts.includes(fileType.toLowerCase());
        },
    },
};
</script>
<style lang="scss" scoped>
.file-select-item {
    display: inline-block;
    position: relative;
    margin: 10px 0;
}
.file-list-item {
    position: relative;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    display: inline-block;
}
.red-border {
    border: 2px solid red;
}
.file-list-item-thumbnail {
    width: 100%;
    height: 100%;
}
.file-list-item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s;
    &::after {
        display: inline-block;
        content: "";
        height: 100%;
        vertical-align: middle
    }

    span {
        display: none;
        cursor: pointer;
    }

    span + span {
        margin-left: 15px;
    }

    &:hover {
        opacity: 1;
        span {
            display: inline-block;
        }
    }
}
.file-list-item-fileName {
    margin: 40% 0;
    text-align: center;
    font-size: 12px;
    word-break: break-all;
}
.file-checkbox {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
}
.prompt-info {
    color: red;
    font-weight: bold;
}
</style>
